import { render, staticRenderFns } from "./SignPanelConfig.vue?vue&type=template&id=1efad25a&scoped=true"
import script from "./SignPanelConfig.vue?vue&type=script&lang=js"
export * from "./SignPanelConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efad25a",
  null
  
)

export default component.exports